/**
 * Multi-game storefront switcher — sets <html data-active-game> + localStorage; reconciles when a saved game has no section on the page.
 */
(function () {
  var DEFAULT_KEY = 'mogo-tycoon:active-game';

  function safeJsonParse(text, label) {
    try {
      return JSON.parse(text);
    } catch (e) {
      console.warn('[game-switcher] invalid JSON (' + label + ')', e);
      return null;
    }
  }

  function uniqueGameIdsFromDom() {
    var seen = {};
    var out = [];
    document.querySelectorAll('[data-game-id]').forEach(function (el) {
      var g = (el.getAttribute('data-game-id') || '').trim();
      if (!g || seen[g]) return;
      seen[g] = true;
      out.push(g);
    });
    return out;
  }

  function findGameMeta(games, id) {
    if (!Array.isArray(games)) return null;
    for (var i = 0; i < games.length; i++) {
      if (games[i] && String(games[i].gameId) === id) return games[i];
    }
    return null;
  }

  function setActiveOnDocument(id, storageKey) {
    document.documentElement.setAttribute('data-active-game', id);
    try {
      localStorage.setItem(storageKey, id);
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('gameSwitcherActiveChange'));
  }

  function reconcile(storageKey, defaultGame) {
    var available = uniqueGameIdsFromDom();
    if (!available.length) return;

    var cur = (document.documentElement.getAttribute('data-active-game') || '').trim();
    var def = defaultGame != null ? String(defaultGame).trim() : '';

    if (cur && available.indexOf(cur) >= 0) return;

    var pick = def && available.indexOf(def) >= 0 ? def : available[0];
    setActiveOnDocument(pick, storageKey);
    if (cur) {
      console.info('[game-switcher] saved game unavailable; falling back to', pick);
    }
  }

  function updatePill(summary, activeId, games) {
    var meta = findGameMeta(games, activeId);
    var labelEl = summary.querySelector('[data-game-switcher-current]');
    var iconWrap = summary.querySelector('[data-game-switcher-icon]');
    var label = meta && meta.label ? String(meta.label) : activeId;
    if (labelEl) labelEl.textContent = label;

    if (iconWrap) {
      iconWrap.innerHTML = '';
      if (meta && meta.iconUrl) {
        var img = document.createElement('img');
        img.className = 'game-switcher__icon-img';
        img.src = meta.iconUrl;
        img.alt = '';
        img.width = 28;
        img.height = 28;
        img.loading = 'lazy';
        iconWrap.appendChild(img);
      }
    }
  }

  function syncOptions(root, activeId) {
    root.querySelectorAll('[data-game-switcher-pick][role="option"]').forEach(function (btn) {
      var gid = (btn.getAttribute('data-game-switcher-pick') || '').trim();
      btn.setAttribute('aria-selected', gid === activeId ? 'true' : 'false');
    });
  }

  function closeDetails(root) {
    var d = root.querySelector('.game-switcher__details');
    if (!d) return;
    d.removeAttribute('open');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  function initRoot(root, config) {
    if (!config) return;

    var storageKey = config.storageKey ? String(config.storageKey) : DEFAULT_KEY;
    var games = Array.isArray(config.games) ? config.games : [];

    var details = root.querySelector('.game-switcher__details');
    var summary = details ? details.querySelector('summary') : null;
    var panel = root.querySelector('.game-switcher__panel');

    function readActiveId() {
      return (document.documentElement.getAttribute('data-active-game') || '').trim();
    }

    function applyUi() {
      var id = readActiveId();
      if (!id) return;
      if (summary) updatePill(summary, id, games);
      syncOptions(root, id);
    }

    if (details) {
      details.addEventListener('toggle', function () {
        var open = details.hasAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          document.querySelectorAll('.game-switcher__details[open]').forEach(function (other) {
            if (other !== details) {
              other.removeAttribute('open');
              var os = other.querySelector('summary');
              if (os) os.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    }

    if (panel) {
      panel.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-game-switcher-pick]') : null;
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        var gid = (btn.getAttribute('data-game-switcher-pick') || '').trim();
        if (!gid) return;
        setActiveOnDocument(gid, storageKey);
        closeDetails(root);
        document.querySelectorAll('.gs--in-header details[open]').forEach(function (d) {
          d.removeAttribute('open');
        });

        var path = window.location.pathname || '';
        var isHomepage =
          path === '/' ||
          path === '' ||
          /^\/$/.test(path) ||
          document.body.classList.contains('template-index');

        var ix = path.indexOf('/collections/');
        var onCollections = ix >= 0;
        var colMap =
          config.collectionsByGameId && typeof config.collectionsByGameId === 'object'
            ? config.collectionsByGameId
            : {};
        var destUrl = gid && colMap[gid];

        if (onCollections && destUrl) {
          window.location.href = destUrl;
          return;
        }

        if (!isHomepage) {
          window.location.href = '/';
          return;
        }
      });

      panel.addEventListener('keydown', function (e) {
        var opts = [];
        panel.querySelectorAll('[data-game-switcher-pick][role="option"]').forEach(function (b) {
          opts.push(b);
        });
        if (!opts.length) return;
        var active = document.activeElement;
        var idx = opts.indexOf(active);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          idx = (idx + 1 + opts.length) % opts.length;
          opts[idx].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          idx = idx <= 0 ? opts.length - 1 : idx - 1;
          opts[idx].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          if (active && active.getAttribute('role') === 'option' && root.contains(active)) {
            e.preventDefault();
            active.click();
          }
        } else if (e.key === 'Escape') {
          closeDetails(root);
          if (summary) summary.focus();
        }
      });
    }

    applyUi();

    document.addEventListener('gameSwitcherActiveChange', applyUi, false);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-game-switcher-root]');
    if (!roots.length) return;

    var merged = {
      storageKey: DEFAULT_KEY,
      defaultGame: 'monopoly-go',
      games: [],
      collectionsByGameId: {}
    };

    for (var r = 0; r < roots.length; r++) {
      var jid = roots[r].getAttribute('data-game-switcher-json-id') || '';
      if (!jid) continue;
      var el = document.getElementById(jid);
      var p = el ? safeJsonParse(el.textContent || '{}', jid) : null;
      if (!p) continue;
      if (p.storageKey) merged.storageKey = String(p.storageKey);
      if (p.defaultGame != null) merged.defaultGame = String(p.defaultGame).trim();
      if (!merged.games.length && Array.isArray(p.games) && p.games.length) merged.games = p.games;
      if (
        p.collectionsByGameId &&
        typeof p.collectionsByGameId === 'object' &&
        !Array.isArray(p.collectionsByGameId) &&
        Object.keys(p.collectionsByGameId).length
      )
        merged.collectionsByGameId = p.collectionsByGameId;
    }

    reconcile(merged.storageKey, merged.defaultGame);

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var myJid = root.getAttribute('data-game-switcher-json-id') || '';
      var myCfg = Object.assign({}, merged);
      if (myJid) {
        var jel = document.getElementById(myJid);
        var parsed = jel ? safeJsonParse(jel.textContent || '{}', myJid) : null;
        if (parsed) Object.assign(myCfg, parsed);
      }
      if (
        !myCfg.collectionsByGameId ||
        typeof myCfg.collectionsByGameId !== 'object' ||
        !Object.keys(myCfg.collectionsByGameId).length
      ) {
        myCfg.collectionsByGameId = merged.collectionsByGameId;
      }
      initRoot(root, myCfg);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
